<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>


                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="title"
                      />

                      <form-error :model="$v.title" :dirty="$v.$dirty" :label="translations.forms.labels.title" />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.description.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">{{ translations.forms.labels.description }}</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea class="form-control form-control-modern" v-model="description" :placeholder="translations.forms.labels.description" />

                      <form-error :model="$v.description" :dirty="$v.$dirty" label="Opis" />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.accountNumber.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Broj računa</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj računa"
                        v-model="accountNumber"
                      />

                      <form-error :model="$v.accountNumber" :dirty="$v.$dirty" label="Broj računa" />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'Banks' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
          <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> Delete Category
          </a>
        </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  components: { FormError },
  name: 'AddBank',
  mixins: [translations],
  validations,
  data() {
    return {
      title: '',
      description: '',
      accountNumber: ''
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const { title, accountNumber, description } = this;

      api.createBank({accountNumber, description, title })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Banks' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
};
</script>